import PoliciesList from "../views/PoliciesList"
import PolicyCommissions from "../views/PolicyCommissions"
import PolicyLogs from "../views/PolicyLogs"
import PolicyTransactions from "../views/PolicyTransactions"
import PolicyDetail from "../views/PolicyDetail"
import PolicyClaims from "../views/PolicyClaims"
import Endorsements from "../views/Endorsements"
import EndorsementsUpdate from "../views/EndorsementsUpdate"

export default [
	{
		path: "/:tenantId/policies",
		component: PoliciesList,
		name: "PoliciesList",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/detail/commission-split/:id",
		component: PolicyCommissions,
		name: "PolicyCommissions",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/detail/logs/:id",
		component: PolicyLogs,
		name: "PolicyLogs",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/detail/transactions/:id",
		component: PolicyTransactions,
		name: "PolicyTransactions",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/detail/claims/:id",
		component: PolicyClaims,
		name: "PolicyClaims",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/detail/policy/:id",
		component: PolicyDetail,
		name: "PolicyDetail",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/detail/endorsements/:id",
		component: Endorsements,
		name: "Endorsements",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/detail/endorsements/update/:id/:endorsementId",
		component: EndorsementsUpdate,
		name: "EndorsementsUpdate",
		meta: { featureId: "policies" },
		props: true
	},

	// NOTE: we agreed that it's not possible to directly create a policy, you have to go through quote
	// Thus we redirect here to quote
	{
		path: "/:tenantId/policies/create-policy-crossroads/",
		meta: { featureId: "policies" },
		props: true,
		redirect: "/:tenantId/quotes/create"
	},
	{
		path: "/:tenantId/policies/create-policy/",
		redirect: "/:tenantId/quotes/create",
		meta: { featureId: "policies" },
		props: true
	},
	{
		path: "/:tenantId/policies/create-policy-with-api/",
		redirect: "/:tenantId/quotes/create",
		meta: { featureId: "policies" },
		props: true
	}
]
